var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicroOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3332 5.83329C16.3332 4.54646 15.2867 3.49996 13.9998 3.49996C12.713 3.49996 11.6665 4.54646 11.6665 5.83329V12.8333C11.6665 14.1201 12.713 15.1666 13.9998 15.1666C15.2867 15.1666 16.3332 14.1201 16.3332 12.8333V5.83329ZM9.33317 5.83329C9.33317 3.25613 11.4227 1.16663 13.9998 1.16663C16.577 1.16663 18.6665 3.25613 18.6665 5.83329V12.8333C18.6665 15.4105 16.577 17.5 13.9998 17.5C11.4227 17.5 9.33317 15.4105 9.33317 12.8333V5.83329ZM23.3332 12.8333V10.5H20.9998V12.8333C20.9998 16.6938 17.8603 19.8333 13.9998 19.8333C10.1393 19.8333 6.99984 16.6938 6.99984 12.8333V10.5H4.6665V12.8333C4.6665 17.5925 8.22938 21.5202 12.8332 22.0944V25.6666H15.1665V22.0944C19.7703 21.5202 23.3332 17.5925 23.3332 12.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicroOn);
export default __webpack_public_path__ + "static/media/icon-micro_on.dcb4413b6012782d3b640436ba51b03d.svg";
export { ForwardRef as ReactComponent };